import {Select} from '@primer/react'
import React, {useMemo} from 'react'

const NEVER_VALUE = ' '

type ExpirationProps = {
  expiresAt?: string | null
  expirationIntervals?: Array<{
    label: string
    time: string
  }>
  expiresIn?: string | null
} & React.ComponentProps<typeof Select>

const ExpirationSelect = ({expiresIn, expiresAt, expirationIntervals, ...rest}: ExpirationProps) => {
  const hasMatchingExpirationInterval = useMemo(() => {
    return Boolean(expiresIn && expirationIntervals?.some(interval => interval.label === expiresIn))
  }, [expirationIntervals, expiresIn])

  const defaultValue = useMemo(() => {
    // If the current expiresIn matches one of the expirationIntervals, use the corresponding time value
    // Else use expiresAt to preserve the custom expiration time
    // If neither is set, default to NEVER_VALUE
    return hasMatchingExpirationInterval
      ? expirationIntervals?.find(interval => interval.label === expiresIn)?.time
      : expiresAt || NEVER_VALUE
  }, [expirationIntervals, expiresIn, expiresAt, hasMatchingExpirationInterval])

  return (
    <Select block name="expires_at" defaultValue={defaultValue} data-testid="user-status-expiration-select" {...rest}>
      <Select.Option value={NEVER_VALUE}>Never</Select.Option>
      {expirationIntervals?.map(({label, time}) => (
        <Select.Option key={time} value={time}>
          {/* capitalize the first letter of label to match `Never` */}
          {label.charAt(0).toUpperCase() + label.slice(1)}
        </Select.Option>
      ))}
      {!hasMatchingExpirationInterval && expiresAt && expiresIn && (
        <Select.Option value={expiresAt}>{expiresIn.charAt(0).toUpperCase() + expiresIn.slice(1)}</Select.Option>
      )}
    </Select>
  )
}

export default ExpirationSelect
ExpirationSelect.__SLOT__ = Select.__SLOT__

try{ ExpirationSelect.displayName ||= 'ExpirationSelect' } catch {}